module.exports = __webpack_public_path__ + "img/bg3.41c880cc.png";